'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

import { listToolbarFilterButtonClass } from '@/core/components/layout/list-toolbar-styles';

export type ListFilterOption = {
  value: string;
  label: string;
};

type ListFilterSelectProps = {
  value: string;
  onValueChange: (value: string) => void;
  options: ListFilterOption[];
  ariaLabel: string;
  className?: string;
};

/** Shared toolbar filter select — same height/chrome as Products/People toolbars. */
export function ListFilterSelect({
  value,
  onValueChange,
  options,
  ariaLabel,
  className,
}: ListFilterSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        aria-label={ariaLabel}
        className={`${listToolbarFilterButtonClass} w-auto min-w-[9rem] ${className ?? ''}`}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent onCloseAutoFocus={(event) => event.preventDefault()}>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

type ListFilterSelectRowProps = {
  children: ReactNode;
  className?: string;
};

export function ListFilterSelectRow({
  children,
  className,
}: ListFilterSelectRowProps) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className ?? ''}`}>
      {children}
    </div>
  );
}
